// extracted by mini-css-extract-plugin
export default {"paginationBox":"index_paginationBox_uEb-g","curPage":"index_curPage_vjKrg","cantClick":"index_cantClick_dfNln","pageNum":"index_pageNum_S5S3g"};